import { gql, useMutation } from '@apollo/client';
import { marked } from 'marked';
import { FC, useState } from 'react';

import SidebarLayout, {
  SidebarLayoutContent,
  SidebarLayoutNavigation,
} from 'layouts/SidebarLayout';

import { FormInput, FormPanel } from 'components/FormPanel';

import CustomChat from './CustomChat';

const UPLOAD_FILE_MUTATION = gql(`
  mutation UploadFile($file: Upload!) {
    uploadPDFForRAGChat(file: $file)
  }
`);

const SEND_MESSAGE_MUTATION = gql(`
  mutation SendMessage($message: String!) {
    sendMessage(message: $message)
  }
`);

const ChatBot: FC = () => {
  const [uploadFile, { loading, error }] = useMutation(UPLOAD_FILE_MUTATION);
  const [sendMessage, { loading: sendMessageLoading, error: sendMessageError }] =
    useMutation(SEND_MESSAGE_MUTATION);
  const [response, setResponse] = useState('');
  const renderContent = () => {
    return (
      <>
        <FormPanel
          onSubmit={data => {
            uploadFile({ variables: { file: data.file } }).then(res => {
              alert('File processed successfully');
            });
          }}
          loading={loading}
          error={error}
          buttonRef={null}
        >
          <FormInput
            type="upload"
            label="Upload File"
            fieldName="file"
            placeholder="Upload File"
            defaultValue={null}
          />
        </FormPanel>
        <FormPanel
          onSubmit={data => {
            setResponse('');
            sendMessage({ variables: { message: data.message } }).then(res => {
              setResponse(res.data.sendMessage);
            });
          }}
          loading={sendMessageLoading}
          error={sendMessageError}
          buttonRef={null}
        >
          <FormInput
            type="text"
            label="Message"
            fieldName="message"
            placeholder="Enter your message"
            defaultValue={null}
          />
        </FormPanel>
        <div className="mt-4">
          <h3 className="text-lg font-medium mb-4">AI Response</h3>
          <div
            className="prose prose-md text-base mt-4 leading-6 p-6 border border-gray-100 rounded-lg min-h-[120px] bg-gray-50"
            dangerouslySetInnerHTML={{
              __html: typeof marked.parse === 'function' ? String(marked.parse(response)) : '',
            }}
          />
        </div>
        <CustomChat />
      </>
    );
  };

  return (
    <SidebarLayout>
      <SidebarLayoutNavigation title="Chat Bot" subTitle="Chat with the chat bot" />
      <SidebarLayoutContent>{renderContent()}</SidebarLayoutContent>
    </SidebarLayout>
  );
};

export default ChatBot;
